import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Advantage
} from "@dndModels";
import { 
  ABILITY_SCORES,
  ABILITY_SCORES_EXPANDED, ATTACK_TYPES 
} from "@dndModels/Constants";
import { AttackType } from "@dndModels/Types";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

import SelectSkillBox from "@dndComponents/select/SelectSkillBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  obj: Advantage;
  onChange: (changed: Advantage) => void; 
  disabled: boolean;
}

export default function AdvantageInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {

  const renderOptions = () => {
    if (obj.type === "Saving Throw") {
      return (
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox 
              name="Saving Throw" 
              options={["ALL","Death Saves",...ABILITY_SCORES_EXPANDED]}
              value={obj.type_detail} 
              disabled={disabled}
              onChange={(changed: string) => {
                const new_obj = obj;
                new_obj.type_detail = changed;
                onChange(new_obj);
              }} 
            />
          </Grid>
          { obj.type_detail === "Selectable" &&
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox
                name="Selectable Key"
                value={obj.selectable_key}
                disabled={disabled}
                onBlur={(changed: string) => {
                  const new_obj = obj;
                  new_obj.selectable_key = changed;
                  onChange(new_obj);
                }}
              />
            </Grid>
          }
        </>
      );
    } else if (obj.type === "Ability Checks") {
      return (
        <Grid
          size={{
            xs: 12
          }}>
          <SelectSkillBox 
            name="Ability Checks" 
            allow_ability_scores
            allow_all
            multiple
            values={obj.type_details} 
            disabled={disabled}
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.type_details = changed;
              onChange(new_obj);
            }} 
          />
        </Grid>
      );
    } else if (obj.type === "Attack") {
      return (
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectObjectBox 
              name="For Class" 
              data_type="game_class"
              value={obj.for_class_id} 
              disabled={disabled}
              onChange={(changed: string) => {
                const new_obj = obj;
                new_obj.for_class_id = changed;
                onChange(new_obj);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox 
              name="Attack Types" 
              options={[...ABILITY_SCORES,...ATTACK_TYPES,"None"]}
              values={obj.type_details} 
              disabled={disabled}
              multiple
              onChange={(changed: AttackType[]) => {
                const new_obj = obj;
                new_obj.type_details = changed;
                onChange(new_obj);
              }}
            />
          </Grid>
        </>
      );
    }
    return null;
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox 
          name="Type" 
          options={["Initiative","Attack","Saving Throw","Ability Checks"]}
          value={obj.type} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.type = changed;
            new_obj.type_detail = "ALL";
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ToggleButtonBox
          name="Disadvantage"
          value={obj.disadvantage}
          disabled={disabled}
          onToggle={() => {
            const new_obj = obj;
            new_obj.disadvantage = !new_obj.disadvantage;
            onChange(new_obj);
          }}
        />
      </Grid>
      { renderOptions() }
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="When" 
          value={obj.formula} 
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.formula = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
    </Grid>
  );
}
